import { handleEvent } from '../../helpers';

export default class {
  constructor(el) {
    this.el = el;
    this.containers = this.el.querySelectorAll('.img-parent');
  }

  init() {
    this.handleEvents()
    this.setupObserver();
  }

  // setup observer
  setupObserver() {

    let thresholdSets = [];
    for (let i = 0; i <= 1.0; i += 0.01) {
      thresholdSets.push(i);
    }

    let intersectionOptions = {
      root: null,
      rootMargin: '0px',
      threshold: thresholdSets
    }

    let observer = new IntersectionObserver(this.callback, intersectionOptions);

    this.containers.forEach(container => {
      observer.observe(container);
    });

  }

  // observer cb
  callback() { }

  // setup scroll event
  handleEvents() {
    this.scroll = handleEvent('scroll', {
      el: window,
      preventDefault: true,
      stopPropagation: true,
      callback: this.onScroll.bind(this)
    });
  }

  // on scroll
  onScroll() {
    this.containers.forEach((container, index) => {
      let factor = 20 * (index + 1);
      let elapsedPx = (container.getBoundingClientRect().y - window.innerHeight);
      let yScroll = parseInt(elapsedPx / factor);
      container.style.transform = 'translateY(' + yScroll + 'px)';
    });
  }

  // cleanup
  destroy() {
    this.scroll.destroy();
    this.containers.forEach(container => {
      observer.unobserve(container);
    });
  }

}
